import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  Grid,
  Typography,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { useAddConfigMutation, useGetConfigQuery } from '../teaAndSnacksApiSlice';
import toast from 'react-hot-toast';
import NavbarLayout from '../../../common/NavbarLayout';
import { FastfoodOutlined } from '@mui/icons-material';
import { variants } from '../../../variants/variants';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLogoutMutation } from '../../Auth/authApiSlice';
import { clearAuth } from '../../Auth/Utility/ClearAuth';

const CanteenAdmin = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [maxData, setMaxData] = useState({
    morningTea: 0,
    eveningTea: 0,
    snack: 0,
    morningEndTime: '',
    eveningStartTime: '',
  });
  const {
    data: configData,
    isLoading: configLoading,
    isError: configError,
  } = useGetConfigQuery({ region: 'Ahmedabad' });
  const [updateConfig] = useAddConfigMutation();
  const [logout] = useLogoutMutation();

  const [dialog, setDialog] = useState(false);
  const [morningEndTime, setMorningEndTime] = useState(maxData?.morningEndTime);
  const [eveningStartTime, setEveningStartTime] = useState(maxData?.eveningStartTime);

  const handleMorningEndTimeChange = (event) => {
    setMorningEndTime(event.target.value);
  };

  const handleEveningStartTimeChange = (event) => {
    setEveningStartTime(event.target.value);
  };
  const handleOpen = () => {
    setDialog(true);
  };

  const handleClose = () => {
    setDialog(false);
  };

  const handleNavigateBack = () => {
    logout();
    clearAuth(dispatch);
    navigate('/auth');
  };

  useEffect(() => {
    if (configData) {
      setMaxData(configData);
    }
  }, [configData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'morningEndTime' || name === 'eveningStartTime') {
      setMaxData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setMaxData((prevState) => ({
        ...prevState,
        [name]: parseInt(value) || 0,
      }));
    }
  };

  const updateMaxCount = async () => {
    await toast.promise(updateConfig(maxData).unwrap(), {
      loading: 'Adding...',
      success: 'Updated',
      error: (err) => err.data?.message || 'Error in Update.',
    });
  };
  return (
    <Grid p={1}>
      <NavbarLayout backButton={false}>
        <Grid display={'flex'} justifyContent={'space-between'} width={'100%'}>
          <Grid item display={'flex'} justifyContent={'start'}>
            <FastfoodOutlined sx={variants.icon.active} />
            <Typography component={'div'} ml={1}>
              Delights{' '}
              <Typography
                sx={{
                  fontSize: variants.BODY,
                  [theme.breakpoints.down('lg')]: {
                    fontSize: variants.TINY,
                  },
                }}
              >
                Having a treat is not a bad idea
              </Typography>
            </Typography>
          </Grid>
          <Button onClick={handleOpen}>Logout</Button>
        </Grid>
      </NavbarLayout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100vw',
        }}
      >
        <TextField
          name="morningTea"
          label="Max Morning Tea"
          fullWidth
          value={maxData.morningTea}
          onChange={handleChange}
          sx={{ maxWidth: '350px' }}
        />
        <TextField
          name="eveningTea"
          label="Max Evening Tea"
          fullWidth
          value={maxData.eveningTea}
          onChange={handleChange}
          sx={{ maxWidth: '350px' }}
        />
        <TextField
          name="snack"
          label="Max Snacks"
          fullWidth
          value={maxData.snack}
          onChange={handleChange}
          sx={{ maxWidth: '350px' }}
        />
        <TextField
          name="morningEndTime"
          label="Morning End Time"
          type="time"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300, // 5 min step
          }}
          fullWidth
          value={maxData.morningEndTime}
          onChange={handleChange}
          sx={{ maxWidth: '350px' }}
        />
        <TextField
          name="eveningStartTime"
          label="Evening Start Time"
          type="time"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300, // 5 min step
          }}
          fullWidth
          value={maxData.eveningStartTime}
          onChange={handleChange}
          sx={{ maxWidth: '350px' }}
        />
        <Button fullWidth variant="contained" onClick={updateMaxCount} sx={{ maxWidth: '350px', borderRadius: '30px' }}>
          Update
        </Button>
        <Dialog
          open={dialog}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Logout'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">Are you sure you want to log out ?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>No</Button>
            <Button onClick={handleNavigateBack} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Grid>
  );
};

export default CanteenAdmin;
